import { combineReducers } from 'redux';
import homeReducer from './home';
import homesReducer from './homes';
import userReducer from './user';
import advertiseReducer from './advertise';
import tenantReducer from './tenant';
import generalReducer from './general';
import conversationReducer from './conversation';

// Root state type
export interface RootState {
  Home: ReturnType<typeof homeReducer>;
  Homes: ReturnType<typeof homesReducer>;
  User: ReturnType<typeof userReducer>;
  Advertise: ReturnType<typeof advertiseReducer>;
  Tenant: ReturnType<typeof tenantReducer>;
  General: ReturnType<typeof generalReducer>;
  Inbox: ReturnType<typeof conversationReducer>;
}

export default combineReducers<RootState>({
  Home: homeReducer,
  Homes: homesReducer,
  User: userReducer,
  Advertise: advertiseReducer,
  Tenant: tenantReducer,
  General: generalReducer,
  Inbox: conversationReducer
});

//export default homeReducer;
